import type { FC } from 'react';
import React, { memo } from 'react';

import type { FeedEventComment as CommentType } from '../../feedCardTypes.ts';

import { Comment } from './Comment.tsx';

type CommentsProps = {
	comments: CommentType[];
	pageId?: string;
	contentType?: string;
};

export const Comments: FC<CommentsProps> = memo(({ comments, pageId, contentType }) => {
	return (
		<div data-testid="feed-card-comments">
			{comments.map((commentData) => {
				if (commentData?.comment) {
					return (
						<Comment
							key={commentData.comment.id}
							user={commentData.user}
							comment={commentData.comment}
							pageId={pageId}
							contentType={contentType}
						/>
					);
				}
				return null;
			})}
		</div>
	);
});
